const scripts = new Map();

export function loadScript(src: string): Promise<void> {
  if (scripts.has(src)) {
    return scripts.get(src);
  }

  const script = document.createElement('script');
  script.async = true;
  const promise = new Promise<void>((resolve, reject) => {
    script.addEventListener('load', () => resolve());
    script.addEventListener('error', () =>
      reject(new Error(`Failed to load script: ${src}.`)),
    );
    script.src = src;
    document.body.appendChild(script);
  });

  scripts.set(src, promise);
  return promise;
}
